// extracted by mini-css-extract-plugin
export default {"page":"SignInPage_page__skkFl","wrapper":"SignInPage_wrapper__TepsR"};